const firebaseConfig = {
    apiKey: "AIzaSyCaK_pcAvFrXnO2S9n6csFm_XIht3F-HMc",
    authDomain: "healthcare-f948e.firebaseapp.com",
    projectId: "healthcare-f948e",
    storageBucket: "healthcare-f948e.appspot.com",
    messagingSenderId: "42369650528",
    appId: "1:42369650528:web:5e268da0e006c351391805",
    measurementId: "G-91STEJ8ZNC"
  };
export default firebaseConfig;  